<template>
  <el-tabs ref='titleBadge' v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane name="first">  
      <span slot="label">  
      全部  
      <el-badge :value="allCount" class="item" type="primary"></el-badge> 
      </span>  
      <LineManVehicleAllList v-if="activeName === 'first'" ref="first" @myevent="getLineManVehicleViewModelsEntity"></LineManVehicleAllList>
    </el-tab-pane> 
    <el-tab-pane name="second">  
      <span slot="label">  
      已绑定  
      <el-badge :value="boundCount" class="item" type="primary"></el-badge> 
      </span>  
      <LineManVehicleBoundList v-if="activeName === 'second'" ref="second" @myevent="getLineManVehicleViewModelsEntity"></LineManVehicleBoundList>
    </el-tab-pane> 
    <el-tab-pane name="third">  
      <span slot="label">  
      未绑定  
      <el-badge :value="unboundCount" class="item"></el-badge>  
      </span>  
      <LineManVehicleUnboundList v-if="activeName === 'third'" ref="third" @myevent="getLineManVehicleViewModelsEntity"></LineManVehicleUnboundList>
    </el-tab-pane>  
  </el-tabs>
</template>
<script>
  import { getLineManVehicleViewModels } from "../../api/api";
  import LineManVehicleAllList from "./LineManVehicleAll";
  import LineManVehicleBoundList from "./LineManVehicleBound";
  import LineManVehicleUnboundList from "./LineManVehicleUnbound";

  export default {
    components: {
      LineManVehicleAllList,
      LineManVehicleBoundList,
      LineManVehicleUnboundList
    },
    data() {
      return {
        activeName: 'first',
        allCount: 0,
        boundCount: 0,
        unboundCount: 0
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      },
      //获取线路人车绑定数量
      getLineManVehicleViewModelsEntity() {
        let para = {
        };
        getLineManVehicleViewModels(para).then(res => {
          this.allCount = res.data.AllCount;
          this.boundCount = res.data.BoundCount;
          this.unboundCount = res.data.UnboundCount;
        });
      }
    },
    mounted(){
      this.getLineManVehicleViewModelsEntity();
    },
  };
</script>